import type { Client } from '@/api/generated/client';
import type { CreateClientConfig } from '@/api/generated/client.gen';
import { ApiError } from '@/lib/errors';

const envBaseUrl = import.meta.env.VITE_API_URL;
const mocksEnabled = import.meta.env.VITE_ENABLE_MOCKS === 'true';

const baseUrl = mocksEnabled ? '' : (envBaseUrl ?? 'http://localhost:3000');

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl,
});

function extractErrorMessage(error: unknown): string {
  if (typeof error === 'string') return error;

  if (error && typeof error === 'object') {
    if ('message' in error && typeof error.message === 'string') return error.message;
    if ('detail' in error && typeof error.detail === 'string') return error.detail;
  }

  return 'Unknown error';
}

export function setupClientErrorHandling(client: Client) {
  client.interceptors.error.use((error, response, request, options) => {
    const path = options?.url || request?.url || 'unknown';
    const errorMessage = extractErrorMessage(error);

    return new ApiError(`API request failed: ${path} - ${errorMessage}`, {
      cause: error,
      status: response?.status,
      statusText: response?.statusText,
      url: request?.url,
      responseData: error,
    });
  });
}
